export const formatPrice = (price) => {
  if (isNaN(price)) return price
  let roundedPrice = Math.round(price * 100) / 100
  let [integerPart, decimalPart] = roundedPrice.toString().split(".")
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  if (decimalPart && decimalPart !== "00") {
    return `${integerPart}.${decimalPart}`
  }

  return `${integerPart}`
}
